/**
 * Página de entrada no MOF novo.
 *
 * Espelho da regra do MOF antigo (site/src/helpers/urlMofNovo.ts — decisão F05B-P3 do TI CEM,
 * 31/08/2026): "Dashboard; se não estiver disponível, Produtos", e depois Liberações e Tarefas, na
 * ordem em que o menu as mostraria. As listas de permissões são as mesmas que o menu usa.
 *
 * "Disponível" tem dois sentidos, e os dois contam: o usuário TER a permissão e o Dashboard EXISTIR
 * neste ambiente (Config.dashboardDisponivel). Incidente de 05/09/2026: a base restaurada do cliente
 * deu ao usuário a tela DashboardSistemista, o MOF antigo mandou-o para /dashboardMof e a página não
 * funciona aqui (as tabelas do módulo Mof.Processa nunca existiram neste banco) — o sistema "parou"
 * já no login. O MOF antigo continua enviando "dashboardMof"; quem decide o destino final é esta
 * função, que também atende "/" e as rotas desconhecidas.
 */

export const PERMISSOES_DASHBOARD = [
  "DashboardSistemista",
  "DashboardVidros",
  "DashboardComponentesSuperficies",
  "DashboardAcabamentos",
];

export const PERMISSOES_PRODUTOS = [
  "CadastroVidros",
  "CadastroPerfis",
  "CadastroComponentes",
  "CadastroSuperficies",
  "CadastroKits",
  "ConsultaProduto",
];

export const PERMISSOES_LIBERACOES = ["Liberacao", "ConsultaLiberacao"];

export const PERMISSOES_TAREFAS = ["GerenciadorTarefas", "Master", "Configuracao"];

export function paginaEntradaMof(
  temPermissao: (permissoes: string[]) => boolean,
  dashboardDisponivel: boolean
): string {
  if (dashboardDisponivel && temPermissao(PERMISSOES_DASHBOARD)) return "/dashboardMof";
  if (temPermissao(PERMISSOES_PRODUTOS)) return "/produtosN1";
  if (temPermissao(PERMISSOES_LIBERACOES)) return "/liberacoesMof";
  if (temPermissao(PERMISSOES_TAREFAS)) return "/quadroTarefas";
  return dashboardDisponivel ? "/dashboardMof" : "/produtosN1";
}
